(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["addon-selector"] && !Shopify.designMode) return;
  try {
    class AddonSelector extends HTMLElement {
    connectedCallback() {
      this.idInput = this.querySelector('[data-addon-id-input]');
      this.qtyInput = this.querySelector('[data-addon-qty-input]');
      this.cardsWrap = this.querySelector('[data-addon-cards]');
      this.info = this.querySelector('[data-addon-info]');

      // Re-bind the hidden inputs to the main product form (closest.product
      // resolves to the add-on product inside this block).
      var mainInput = document.querySelector('[data-product-form-id-input]');
      if (mainInput && mainInput.form) {
        this.idInput.setAttribute('form', mainInput.form.id);
        this.qtyInput.setAttribute('form', mainInput.form.id);
      }

      this.querySelectorAll('[data-addon-mode]').forEach(function (input) {
        input.addEventListener('change', this.sync.bind(this));
      }, this);
      this.querySelectorAll('[data-addon-card]').forEach(function (input) {
        input.addEventListener('change', this.sync.bind(this));
      }, this);

      var more = this.querySelector('[data-addon-more]');
      if (more && this.info) {
        more.addEventListener('click', function () {
          this.info.hidden = !this.info.hidden;
        }.bind(this));
      }

      this.sync();
    }

    sync() {
      var yes = this.querySelector('[data-addon-mode][value="yes"]').checked;
      var card = this.querySelector('[data-addon-card]:checked');
      this.cardsWrap.hidden = !yes;
      var enabled = yes && !!card;
      this.idInput.disabled = !enabled;
      this.qtyInput.disabled = !enabled;
      if (card) {
        this.idInput.value = card.value;
        this.qtyInput.value = card.dataset.qty || 1;
      }
    }
  }

  customElements.define('addon-selector', AddonSelector);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    (function () {
    document.addEventListener('theme:variant:change', function (event) {
      var variant = event.detail.variant;

      document.querySelectorAll('[data-buy-buttons]').forEach(function (root) {
        var button = root.querySelector('[data-add-to-cart]');
        var text = root.querySelector('[data-add-to-cart-text]');

        if (!variant) {
          button.disabled = true;
          text.textContent = root.dataset.labelUnavailable;
          return;
        }

        button.disabled = !variant.available;
        text.textContent = variant.available ? root.dataset.labelAdd : root.dataset.labelSoldOut;
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["delivery-countdown"] && !Shopify.designMode) return;
  try {
    class DeliveryCountdown extends HTMLElement {
    connectedCallback() {
      this.cutoffHour = parseInt(this.dataset.cutoffHour, 10) || 16;
      this.minDays = parseInt(this.dataset.minDays, 10) || 3;
      this.maxDays = parseInt(this.dataset.maxDays, 10) || 7;
      this.tick();
      this.timer = setInterval(this.tick.bind(this), 30000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    tick() {
      var now = new Date();
      var cutoff = new Date(now);
      cutoff.setHours(this.cutoffHour, 0, 0, 0);
      if (cutoff <= now) cutoff.setDate(cutoff.getDate() + 1);

      var mins = Math.max(1, Math.round((cutoff - now) / 60000));
      var h = Math.floor(mins / 60);
      var m = mins % 60;
      this.querySelector('[data-countdown]').textContent = h > 0 ? h + 'h ' + m + 'm' : m + 'm';

      var opts = { month: 'short', day: 'numeric' };
      var min = new Date(now); min.setDate(min.getDate() + this.minDays);
      var max = new Date(now); max.setDate(max.getDate() + this.maxDays);
      this.querySelector('[data-eta-min]').textContent = min.toLocaleDateString(undefined, opts);
      this.querySelector('[data-eta-max]').textContent = max.toLocaleDateString(undefined, opts);
    }
  }

  customElements.define('delivery-countdown', DeliveryCountdown);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["package-cards"] && !Shopify.designMode) return;
  try {
    class PackageCards extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-package-cards-json]').textContent);
      this.addEventListener('change', this.announce.bind(this));

      // Sync the preselected card (which may not be the first variant) once
      // every other block has registered its listeners. All block scripts run
      // synchronously in one bundle, so a macrotask is always late enough.
      var self = this;
      setTimeout(function () { self.announce(); }, 0);
    }

    announce() {
      var checked = this.querySelector('input[type="radio"]:checked');
      if (!checked) return;

      var variant = this.variants.find(function (variant) {
        return String(variant.id) === checked.value;
      });
      if (!variant) return;

      var idInput = document.querySelector('[data-product-form-id-input]');
      if (idInput) idInput.value = variant.id;

      document.dispatchEvent(new CustomEvent('theme:variant:change', {
        bubbles: true,
        detail: { variant: variant }
      }));
    }
  }

  customElements.define('package-cards', PackageCards);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["price"] && !Shopify.designMode) return;
  try {
    (function () {
    function updatePrice(root, variant) {
      var regular = root.querySelector('[data-price-regular]');
      var sale = root.querySelector('[data-price-sale]');
      var savings = root.querySelector('[data-price-savings]');
      var onSale = variant.compareAtPrice > variant.price;

      regular.hidden = !onSale;
      regular.textContent = variant.compareAtPriceFormatted;
      sale.textContent = variant.priceFormatted;
      savings.hidden = !onSale;
      savings.textContent = variant.savingsFormatted || '';
    }

    document.addEventListener('theme:variant:change', function (event) {
      document.querySelectorAll('[data-price]').forEach(function (root) {
        updatePrice(root, event.detail.variant);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-addon"] && !Shopify.designMode) return;
  try {
    class ProductAddon extends HTMLElement {
    connectedCallback() {
      this.idInput = this.querySelector('[data-addon-id-input]');
      this.qtyInput = this.querySelector('[data-addon-qty-input]');

      // `closest.product` resolves to the add-on product inside this block,
      // so the Liquid-rendered form id can point at the wrong form. Re-bind
      // the hidden inputs to the form that owns the main variant id input.
      var mainInput = document.querySelector('[data-product-form-id-input]');
      if (mainInput && mainInput.form) {
        this.idInput.setAttribute('form', mainInput.form.id);
        this.qtyInput.setAttribute('form', mainInput.form.id);
      }
      this.qtyWrap = this.querySelector('[data-addon-qty-wrap]');
      this.qtyValue = this.querySelector('[data-addon-qty-value]');
      this.priceLabel = this.querySelector('[data-addon-price-label]');
      this.unitPrice = parseInt(this.dataset.price, 10);
      this.maxQty = parseInt(this.querySelector('[data-addon-max-qty]').textContent, 10) || 1;
      this.qty = 1;

      this.querySelector('[data-addon-toggle]').addEventListener('change', this.onToggle.bind(this));
      this.querySelector('[data-addon-qty-minus]').addEventListener('click', this.step.bind(this, -1));
      this.querySelector('[data-addon-qty-plus]').addEventListener('click', this.step.bind(this, 1));
    }

    onToggle(event) {
      var enabled = event.target.checked;
      this.qtyWrap.hidden = !enabled || this.maxQty < 2;
      this.idInput.disabled = !enabled;
      this.qtyInput.disabled = !enabled;
    }

    step(delta) {
      this.qty = Math.min(this.maxQty, Math.max(1, this.qty + delta));
      this.qtyValue.textContent = this.qty;
      this.qtyInput.value = this.qty;

      var total = (this.unitPrice * this.qty) / 100;
      var formatted = total % 1 === 0 ? total.toFixed(0) : total.toFixed(2);
      this.priceLabel.textContent = '+$' + formatted;
    }
  }

  customElements.define('product-addon', ProductAddon);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variant-picker"] && !Shopify.designMode) return;
  try {
    class VariantPicker extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-variant-picker-json]').textContent);
      this.addEventListener('change', this.onChange.bind(this));
    }

    onChange() {
      var selections = Array.from(this.querySelectorAll('fieldset')).map(function (fieldset) {
        var checked = fieldset.querySelector('input:checked');
        return checked ? checked.value : null;
      });

      var variant = this.variants.find(function (variant) {
        return variant.options.every(function (option, index) {
          return option === selections[index];
        });
      });

      if (!variant) return;

      var idInput = document.querySelector('[data-product-form-id-input]');
      if (idInput) idInput.value = variant.id;

      document.dispatchEvent(new CustomEvent('theme:variant:change', {
        bubbles: true,
        detail: { variant: variant }
      }));
    }
  }

  customElements.define('variant-picker', VariantPicker);
  } catch(e) { console.error(e); }
})();

})();
